/* eslint-disable prettier/prettier */
// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import YouTubeIcon from "@mui/icons-material/YouTube";
import InstagramIcon from "@mui/icons-material/Instagram";

// Material Kit 2 React components
import MKTypography from "components/MKTypography";

// Images
import logoCT from "assets/images/logo.webp";
import membruPic from "assets/images/membru-pic.jpg";

const date = new Date().getFullYear();

export default {
    brand: {
        name: "Doral Cleaning - Servicii profesionale de curatenie",
        image: logoCT,
        route: "/",
        address: {
            text: "Calea Șerban Vodă 82, Sector 4, 040213",
            mapLink: "https://maps.app.goo.gl/ZvLDzHRXk4KXUUwS6",
        },
        phone: "0730 407 322",
        schedule: ["Program de lucru:", "Luni - Vineri: 08:00 - 17:00", "Sâmbătă: 09:00 - 14:30"],
    },
    socials: [
        {
            icon: <FacebookIcon />,
            link: "https://www.facebook.com/share/14Nc3PA7p7E/?mibextid=wwXIfr",
        },
        {
            icon: <YouTubeIcon />,
            link: "https://youtube.com/@doralcleaning?si=caOCgnBRitWdF7f3",
        },
        {
            icon: <InstagramIcon />,
            link: "https://www.instagram.com/doralcleaning_?igsh=MXh0cmkzb3p3M2dudA==y",
        },
    ],
    menus: [
        {
            name: "Servicii",
            items: [
                {
                    name: "Curățenie birouri și spații comerciale",
                    route: "/curatenie-birouri-firme-spatii-comerciale/",
                },
                {
                    name: "Curățenie hale, fabrici și depozite",
                    route: "/curatenie-fabrici-depozite-hale/",
                },
            ],
        },
        {
            name: "Companie",
            items: [
                { name: "Des-Spre Noi", route: "/despre-noi-curatenie/" },
                { name: "Blog", route: "/blog/" },
                { name: "Contact", route: "/contact-curatenie/" },
            ],
        },
        {
            name: "Sitemap",
            items: [{ name: "Sitemap", route: "/sitemap/" }],
        },
        {
            name: "Legal",
            items: [
                { name: "Termeni & Condiții", route: "/termene-conditii/" },
                {
                    name: "Politica de confidentialitate",
                    route: "/politica-confidentialitate/",
                },
                { name: "Politica Cookie", route: "/politica-cookie/" },
            ],
        },
    ],
    membruPic: {
        image: membruPic,
        alt: "Membru în Patronatul Industriei de Curățenie",
        link: "https://www.patronatulcurateniei.ro/",
    },
    copyright: (
        <MKTypography variant="button" fontWeight="regular">
            Toate drepturile rezervate. Copyright &copy; {date}{" "}
            <MKTypography
                component="a"
                href="https://fujix-optimization.com/"
                target="_blank"
                rel="noreferrer"
                variant="button"
                fontWeight="regular"
            >
                fujix
            </MKTypography>
            .
        </MKTypography>
    ),
};
